enum Direction
{
    next,
    previous
}

export default Direction